const and32 = (a, b) => a & b;
export default and32;
